export default __webpack_public_path__ + "static/media/7.9ac82ad7.png";